module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/logo-coj-ja-43f3ecaa02de5cb08555dff6d5ae5414.svg";